import React from 'react';
import { browserHistory } from 'react-router';
import commonUtil from '../../../../utils/commonUtil';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearEventData } from '../../../createEvent/actions';
import { clearEventPersonalization } from '../../../createEvent/components/createEvent/actions';
import CTA from '../../Content/MarketingSectionContainer/global/CTA';

const applicationRoutes = commonUtil.getApplicationRoutes();

const Beneficios = ({ state, clearEventPersonalization, clearEventData }) => {
  const eventTypes = state?.eventcategory?.data?.eventConfigurations || [];
  const user = state?.cscAdminProfile?.data || {};
  let redirectUrl = null;
  if (typeof window !== 'undefined') {
    redirectUrl = localStorage?.getItem('eventredirectUrl'); // Retrieve it
  }
  const allowedEventTypes =
    state?.allowedEventTypes?.data?.data?.eventTypesInfo
      ?.filter((eventType) => eventType.available)
      ?.map((eventType) => eventType.eventType) || [];

  const isuserLoggedIn =
    state?.user?.data?.result?.error == 'Unauthorized' ||
    state?.user?.data?.result?.title == 'Unauthorized' ||
    !state?.user?.data?.result?.profileId
      ? false
      : true;
  if (isuserLoggedIn && redirectUrl) {
    localStorage?.removeItem('eventredirectUrl'); // Remove it from localStorage
    browserHistory.push(redirectUrl); // Redirect to the stored URL
  }
  return eventTypes?.map((eventType) => {
    const action_disabled =
      isuserLoggedIn && allowedEventTypes?.indexOf(eventType?.name) < 0;
    const benefits = eventType?.benefits;
    const section_classes = benefits?.action_button?.button_url?.replaceAll(
      '/',
      ' ',
    );
    const section_selectors = benefits?.action_button?.button_url?.replaceAll(
      '/',
      '.',
    );

    const handleClick = () => {
      if (isuserLoggedIn) {
        clearEventPersonalization();
        clearEventData();
        browserHistory.push(benefits?.action_button?.button_url);
        document.body.classList.remove('modal-open');
      } else {
        commonUtil.handleRedirect();
        localStorage?.setItem(
          'eventredirectUrl',
          benefits?.action_button?.button_url,
        );
      }
    };

    return (
      <div
        style={{ display: 'none' }}
        className={`modal-overlay beneficios ${section_classes}`}
      >
        <div className='modal-content-event'>
          <div className='evnt-modal-header'>
            <h4 className='modal-title benificios-title-bold'>
              {benefits?.title}
            </h4>
            <button
              className='close-button'
              aria-label='Cerrar modal'
              onClick={() => {
                const modal = document.querySelector(
                  `.modal-overlay.beneficios${section_selectors}`,
                );
                if (modal) {
                  modal.style.display = 'none';
                }
                document.body.classList.remove('modal-open');
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z'
                  fill='#333333'
                />
              </svg>
            </button>
          </div>
          <div className='evnt_modal_body'>
            {
              <div
                dangerouslySetInnerHTML={{
                  __html: benefits?.content,
                }}
              />
            }
            {/* <button
              className={`${eventType?.name} evnt_btn_primary${
                action_disabled ? " btn-disabled" : ""
              }`}
              disabled={action_disabled} 
              onClick={handleClick}>
              {benefits?.action_button?.button_text}
            </button> */}
            {user && user.isAgent ? (
              <></>
            ) : (
              <CTA
                cta={{
                  title: benefits?.action_button?.button_text,
                  disabled: action_disabled,
                  customBtnCss: `${eventType?.name} evnt_btn_primary${
                    action_disabled ? ' btn-disabled' : ''
                  }`,
                  customHandleClick: handleClick,
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  });
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearEventData,
      clearEventPersonalization,
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(Beneficios);
